// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","container":"Loader_container__X02md","bar":"Loader_bar__H3aY8","scale-up4":"Loader_scale-up4__+Crki"};